/** Fase 2 (W12): textos de Assinaturas e recorrência (Contratos e Reajustes) em pt, en e es. */
const pt = {
  nome: 'Assinaturas e recorrência',
  buscaGlobal: { contratos: 'Contratos de assinatura' },
  abas: { contratos: 'Contratos', reajustes: 'Reajustes', planos: 'Planos', onboarding: 'Onboarding' },
  indicadores: { mrr: 'MRR', reajustes_pendentes: 'Reajustes pendentes' },
  onboarding: {
    config: {
      titulo: 'Ciclo do cliente',
      onboarding: 'Onboarding na ativação do contrato',
      onboardingAjuda: 'Ao ativar um contrato, abre o onboarding do cliente: dados fiscais, convite para o app, primeira cobrança Pix e boas-vindas. Não mexe nos contratos já ativos.',
      ganhoAtivo: 'Contrato ativo direto no ganho',
      ganhoAtivoAjuda: 'O contrato proposto no ganho da oportunidade (com os itens dela) nasce ativo e já fatura; desligado, nasce em rascunho para conferência.',
      exigePortal: 'Ligar exige também a permissão de convidar ao Portal do cliente (Comercial > Portal do cliente > Acessos ao portal), que você não tem.',
      tarefas: 'Etapas manuais viram tarefa',
      quadro: 'Quadro das tarefas',
      quadroPadrao: 'Quadro padrão',
      inadimplencia: 'Tolerância da inadimplência, em dias',
      inadimplenciaFaixa: 'Use de 0 a 90 dias',
      ativarAoAssinar: 'Ativar o contrato ao assinar',
      ativarAoAssinarAjuda: 'Por empresa. Quando todos assinam o documento do contrato gerado de modelo, o contrato em rascunho ativa e emite a primeira cobrança, com a permissão de quem enviou para assinatura. Desligada, o contrato recebe uma nota e quem gerou o documento é avisado.',
      ganho: 'No ganho da oportunidade',
      ganhoAvisar: 'Quem é avisado',
      ganhoAvisarTodos: 'Quem tem acesso a Assinaturas (padrão)',
      ganhoAvisarIncluir: 'Incluir pessoa',
      ganhoAvisarRemover: 'Tirar {{nome}} do aviso',
      ganhoAvisarAjuda: 'Cada contrato que nasce do ganho avisa estas pessoas (sino e celular), com o link para o contrato. Sem ninguém escolhido, avisa quem tem acesso a Assinaturas na empresa do contrato; cada pessoa ajusta o canal nas preferências de notificação.',
      ganhoTarefa: 'Tarefa para o setor responsável',
      ganhoTarefaAjuda: 'Cada contrato que nasce do ganho vira um card no quadro do setor, ligado ao contrato e com o link para ele em Assinaturas.',
      ganhoQuadro: 'Quadro do setor',
      ganhoResponsavel: 'Responsável pelo card',
      semResponsavel: 'Sem responsável',
      inadimplenciaAjuda: 'O contrato com fatura em aberto vencida há mais que estes dias aparece como inadimplente e a equipe é avisada. A cobrança ao cliente segue a régua do Contas.',
    },
    modelo: {
      titulo: 'Modelo de onboarding',
      padraoAjuda: 'Este é o modelo padrão. Personalize para mudar textos, prazos e etapas.',
      ajuda: 'As mudanças valem para os onboardings que abrirem depois; os abertos ficam como estão.',
      personalizar: 'Personalizar',
      nova: 'Nova etapa',
      editar: 'Editar etapa',
      remover: 'Remover etapa',
      removerTitulo: 'Remover esta etapa do modelo?',
      removerTexto: 'Os onboardings já abertos ficam como estão.',
      campoTitulo: 'Título',
      campoDescricao: 'Descrição',
      campoMensagem: 'Texto da mensagem de boas-vindas',
      campoPrazo: 'Prazo em dias',
      prazo_one: '{{count}} dia',
      prazo_other: '{{count}} dias',
      semPrazo: 'Sem prazo',
    },
    tipos: { dados_fiscais: 'Automática: dados fiscais', convite_portal: 'Automática: convite ao app', cobranca_pix: 'Automática: cobrança Pix', boas_vindas: 'Automática: boas-vindas', manual: 'Manual' },
    estadoPasso: { pendente: 'Pendente', aguardando: 'Aguardando', concluido: 'Concluída', falhou: 'Com falha', dispensado: 'Dispensada' },
    estadoOnboarding: { em_andamento: 'Em andamento', concluido: 'Concluído', cancelado: 'Cancelado' },
    ficha: {
      titulo: 'Onboarding',
      doContrato: 'Onboarding do contrato {{numero}}',
      unico_one: 'Onboarding do cliente',
      unico_other: 'Onboarding do cliente: {{count}} contratos do mesmo ganho, um por empresa',
      desde: 'desde {{data}}',
      prazo: 'até {{data}}',
      executar: 'Executar de novo',
      concluir: 'Marcar como concluída',
      dispensar: 'Dispensar',
      reabrir: 'Reabrir',
    },
    detalhes: {
      sem_documento: 'Cadastre o CPF ou CNPJ do cliente (obrigatório para cobrar)',
      cliente_indisponivel: 'Cliente indisponível no Cadastros',
      portal_ausente: 'O Portal do cliente não está instalado',
      sem_email: 'Cadastre o e-mail do cliente ou de um contato',
      convite_enviado: 'Convite enviado ao contato principal',
      ja_tinha_acesso: 'O contato já tinha acesso ao app',
      aguardando_dados_fiscais: 'Esperando os dados fiscais',
      aguardando_fatura: 'Esperando a primeira fatura do contrato',
      aguardando_pagamento: 'Cobrança Pix pedida; conclui quando o pagamento cair',
      fatura_paga: 'A primeira fatura já estava paga',
      pagamento_confirmado: 'Pagamento confirmado',
      contas_ausente: 'O Contas não está disponível para cobrar',
      aguardando_convite: 'Esperando o convite ao app',
      mensagem_enviada: 'Mensagem enviada no app',
      tarefa_criada: 'Tarefa #{{numero}} criada',
      tarefa_nao_criada: 'A tarefa não foi criada',
      marcado_pela_equipe: 'Marcada pela equipe',
      sem_permissao: 'Quem executou esta etapa não tem a permissão dela: alguém com a permissão usa "Executar de novo"',
      sem_permissao_manual: 'A tarefa desta etapa não foi criada: quem ativou o contrato não pode criar tarefas. Alguém com a permissão usa "Executar de novo"',
      simulacao_manual: 'A tarefa desta etapa não foi criada porque o contrato foi ativado numa simulação. Alguém com a permissão usa "Executar de novo"',
      simulacao: 'Esta etapa não foi executada porque a ação foi feita numa simulação: alguém com a permissão usa "Executar de novo"',
    },
  },
  anexarAssinado: {
    titulo: 'Anexar contrato assinado',
    ajuda: 'Para o contrato já assinado fora do sistema: o PDF fica ligado a este contrato, em Cadastros > Documentos e assinatura > Contratos, sem gerar de novo.',
    nome: 'Nome do documento',
    nomeAjuda: 'Vazio: o nome do arquivo',
    arquivo: 'Arquivo assinado (PDF)',
    escolher: 'Escolher arquivo',
    trocar: 'Trocar arquivo',
    anexar: 'Anexar',
    anexado: 'Contrato assinado anexado',
    arquivoObrigatorio: 'Escolha o arquivo do contrato assinado',
  },
  documento: {
    titulo: 'Gerar documento do contrato',
    gerar: 'Gerar documento',
    ajuda: 'O documento sai do modelo do Word com os dados do contrato, do cliente e da empresa. Fica em Cadastros > Documentos e assinatura > Contratos, em PDF para assinar.',
    ajudaSemPdf: 'O documento sai do modelo do Word com os dados do contrato, do cliente e da empresa. Este servidor ainda não converte para PDF: o documento sai em .docx.',
    modelo: 'Modelo',
    sugerido: '{{nome}} (sugerido)',
    escolha: 'Escolha o modelo',
    versao: 'Versão {{versao}} do modelo',
    garantidor: 'Sócio garantidor',
    garantidorAjuda: 'Quem assina como garantidor ou devedor solidário.',
    campos: 'Campos do documento',
    doSistema: 'Preenchido pelo sistema; dá para corrigir.',
    pendentes_one: 'Falta preencher {{count}} campo obrigatório.',
    pendentes_other: 'Faltam preencher {{count}} campos obrigatórios.',
    semModelo: 'Nenhum modelo de contrato do Word ativo. Importe em Cadastros > Documentos e assinatura > Contratos > Modelos.',
    gerado: 'Documento gerado.',
    geradoSemPdf: 'Documento gerado em .docx (sem PDF neste servidor).',
  },
  aditivo: {
    titulo: 'Gerar aditivo ou termo',
    gerar: 'Gerar aditivo ou termo',
    evento: 'Evento',
    eventos: { suspensao: 'Suspensão', reativacao: 'Reativação', migracao_plano: 'Migração de plano', troca_regime: 'Troca de regime', rescisao: 'Rescisão sem débitos', cessao: 'Cessão para outra empresa do grupo', rescisao_inadimplencia: 'Rescisão por inadimplência (termo para ciência do cliente)' },
    antigo: 'Contrato antigo (sem contrato gerado no MalgoOS): servem também os modelos "só contratos antigos".',
    data: 'A partir de',
    dataRescisao: 'Data do efeito da rescisão',
    dataCessao: 'Data da cessão',
    destino: 'Empresa que recebe o contrato',
    destinoAjuda: 'Na assinatura, o contrato nasce nesta empresa com os mesmos itens a partir da data, e o desta empresa se encerra (conta como saída aqui e entrada lá).',
    escolhaDestino: 'Escolha a empresa',
    faltaDestino: 'Escolha a empresa que recebe para a cessão valer na assinatura.',
    dataAjuda: 'Vazio: hoje.',
    plano: 'Plano novo',
    planoAjuda: 'O novo valor do aditivo sai do plano escolhido no catálogo de Planos.',
    escolhaPlano: 'Escolha o plano',
    efeito: 'Quando a mudança vale',
    efeitos: { ja: 'Vale já', assinatura: 'Vale na assinatura' },
    ajuda: {
      ja: 'O documento só formaliza: faça a mudança no contrato como sempre.',
      assinatura: 'O sistema aplica a mudança no contrato quando todos assinarem, com as permissões de quem enviar para assinatura.',
    },
    soFormaliza: 'A troca de regime só se formaliza: o regime muda no cadastro do cliente.',
    faltaPlano: 'Escolha o plano novo: o novo valor do aditivo sai dele.',
    semModelo: 'Nenhum modelo do Word de aditivo ou termo para este evento. Importe em Cadastros > Documentos e assinatura > Contratos > Modelos, com o tipo e o evento.',
    geradoPendente: 'Documento gerado. A mudança vale quando todos assinarem.',
  },
  acoes: {
    gerarDocumento: 'Gerar documento',
    gerarAditivo: 'Gerar aditivo ou termo',
    anexarAssinado: 'Anexar contrato assinado',
    novo: 'Novo contrato',
    importar: 'Importar CSV',
    importarTitulo: 'Importar contratos',
    editar: 'Editar',
    pausar: 'Pausar',
    retomar: 'Retomar',
    ativar: 'Ativar',
    encerrar: 'Encerrar contrato',
    reativar: 'Reativar contrato',
    faturar: 'Tentar de novo',
    excluir: 'Excluir rascunho',
    aprovar: 'Aprovar',
    recusar: 'Recusar',
    editarContrato: 'Editar contrato',
    verFatura: 'Ver fatura no Contas',
  },
  campos: {
    numero: 'Número',
    referencia: 'Referência externa',
    cliente: 'Cliente',
    vendedor: 'Vendedor',
    tipo: 'Tipo de contrato',
    inicio: 'Data de início',
    primeiraCobranca: 'Primeira cobrança',
    intervalo: 'Recorrência',
    intervaloMeses: 'A cada',
    fimTipo: 'Prazo do contrato',
    fimData: 'Data de término',
    fimCobrancas: 'Número de cobranças',
    diaGeracao: 'Dia de geração do título',
    diaVencimento: 'Dia de vencimento',
    momento: 'Tipo de pagamento',
    forma: 'Método de pagamento',
    condicao: 'Condição de pagamento',
    descontoTipo: 'Desconto',
    desconto: 'Desconto em valor',
    descontoPct: 'Desconto em %',
    indice: 'Índice de reajuste',
    observacoes: 'Observações da fatura',
    estado: 'Estado',
    valorCiclo: 'Valor do ciclo',
    mrr: 'MRR',
    saude: 'Saúde do faturamento',
    proxima: 'Próxima cobrança',
    termino: 'Término',
    competencia: 'Competência',
    geracao: 'Geração',
    vencimento: 'Vencimento',
    valor: 'Valor',
    fator: 'Fator acumulado',
    repete: 'Repete a cada',
    unidade: 'Unidade de repetição',
    empresa: 'Empresa',
    centroCusto: 'Centro de custo',
    plano: 'Plano',
    planoInativo: 'Plano indisponível',
  },
  tipos: { recorrente: 'Recorrente', avulso: 'Avulso (cobrança única)' },
  fins: { indeterminado: 'Indeterminado', data: 'Até uma data', cobrancas: 'Número de cobranças' },
  momentos: { vigente: 'Mês vigente', subsequente: 'Mês subsequente' },
  indices: { nenhum: 'Nenhum', igpm: 'IGP-M', ipca: 'IPCA', inpc: 'INPC', selic: 'SELIC' },
  estados: { rascunho: 'Rascunho', ativo: 'Ativo', pausado: 'Pausado', encerrado: 'Encerrado' },
  estadosCobranca: { agendada: 'Agendada', emitida: 'Emitida', falhou: 'Falhou', cancelada: 'Cancelada' },
  motivos: { encerramento: 'Cancelada no encerramento', pausa: 'Cancelada pela pausa' },
  descontoTipos: { nenhum: 'Sem desconto', valor: 'Em valor', percentual: 'Em percentual' },
  areas: { identificacao: 'Identificação', servicos: 'Serviços do contrato', vigencia: 'Tipo e vigência', pagamento: 'Pagamento' },
  unidades: { dia: 'Dias', semana: 'Semanas', mes: 'Meses' },
  intervalos: { '1': 'Mensal', '3': 'Trimestral', '6': 'Semestral', '12': 'Anual', semanal: 'Semanal', outro: 'Outro intervalo' },
  recorrencia: { aCadaSemanas_one: 'A cada {{count}} semana', aCadaSemanas_other: 'A cada {{count}} semanas', aCadaDias_one: 'A cada {{count}} dia', aCadaDias_other: 'A cada {{count}} dias', diaria: 'Diária', aCada_one: 'A cada {{count}} mês', aCada_other: 'A cada {{count}} meses', avulso: 'Cobrança única' },
  itens: {
    titulo: 'Serviços do contrato',
    servico: 'Serviço',
    semServico: 'Sem serviço do catálogo',
    descricao: 'Descrição na fatura do serviço {{n}}',
    quantidade: 'Quantidade',
    preco: 'Preço unitário',
    custo: 'Custo unitário',
    categoria: 'Conta financeira (receita)',
    semCategoria: 'Sem categoria',
    centro: 'Centro de custo',
    semCentro: 'Sem centro de custo',
    total: 'Total',
    adicionar: 'Adicionar serviço',
    remover: 'Remover serviço',
    bruto: 'Valor bruto',
    desconto: 'Desconto',
    liquido: 'Valor do ciclo',
    mrr: 'MRR do contrato',
    vazio: 'Nenhum item. Contrato ativo precisa de pelo menos um item.',
    incompleto: 'Preencha a descrição e um preço válido em cada item.',
    recorrencia: 'Recorrência',
    daContrato: 'A do contrato',
  },
  recorrenciaItem: { avulso: 'Avulso (só na 1ª cobrança)', mensal: 'Mensal', trimestral: 'Trimestral', semestral: 'Semestral', anual: 'Anual' },
  ajuda: {
    primeiraCobranca: 'O mês dela é a competência da primeira cobrança.',
    diaGeracao: 'Dia em que a fatura nasce no Contas. Se cair depois do vencimento, nasce no mês anterior.',
    diaVencimento: 'Vazio: o dia da primeira cobrança. Dia 31 vira o último dia em meses curtos.',
    indice: 'Um mês antes de cada aniversário nasce uma aprovação com o acumulado de 12 meses.',
    referencia: 'Número do contrato no sistema de origem (usado na importação).',
    momento: 'Vigente: vence no mês da competência (por dia ou semana, na data do ciclo). Subsequente: vence no mês seguinte (por dia ou semana, no ciclo seguinte).',
    empresa: 'A empresa (CNPJ) do contrato e das cobranças dele. Com o filtro do topo numa empresa, é ela.',
    centroCusto: 'Padrão dos serviços sem centro de custo.',
    numeroAoSalvar: 'Gerado ao salvar',
    unidade: 'Por dia ou por semana, a fatura nasce na data de cada ciclo; dia de geração e dia de vencimento não se aplicam.',
    plano: 'Traz os itens e a recorrência do plano; tudo continua editável.',
    planoEdicao: 'Trocar o plano não muda os itens deste contrato.',
  },
  saude: {
    emDia: 'Em dia',
    falhas_one: '{{count}} cobrança com falha',
    falhas_other: '{{count}} cobranças com falha',
    ultima: 'Última emitida: {{competencia}}',
    semEmissao: 'Nenhuma fatura emitida ainda',
    proxima: 'Próxima: {{competencia}}, gera em {{data}}',
    semProxima: 'Sem próxima cobrança agendada',
    ultimoErro: 'Último erro: {{erro}}',
  },
  banco: { titulo: 'Cobrança', rotulo: 'Banco da cobrança', ajuda: 'Banco que gera a cobrança das faturas deste contrato.', segue: 'Segue o cliente, a empresa e o workspace', opcoes: { asaas: 'Asaas', sicredi: 'Pix Sicredi', nenhum: 'Nenhum (sem cobrança)' } },
  detalhe: {
    resumo: 'Resumo',
    cobrancas: 'Cobranças',
    previsao: 'Próximas cobranças',
    reajustes: 'Reajustes',
    semReajustes: 'Nenhum reajuste até agora.',
    semCobrancas: 'Nenhuma cobrança planejada. Rascunho e contrato sem item não faturam.',
    reajustada: 'Reajustada',
    tentativas_one: '{{count}} tentativa',
    tentativas_other: '{{count}} tentativas',
    cobrancasLegenda: 'Previsão de 12 meses: as agendadas viram fatura no Contas no dia de geração.',
    cobrancasLegendaDias: 'Previsão de 2 meses: as agendadas viram fatura no Contas no dia de geração.',
    carregarAnteriores: 'Carregar cobranças anteriores',
  },
  mrr: {
    titulo: 'MRR',
    arr: 'ARR',
    pausado: 'MRR pausado',
    aIniciar: 'MRR a iniciar',
    movimento: 'Movimento do mês',
    detalheMovimento: 'Novo {{novo}}, expansão {{expansao}}, churn {{churn}}',
    contratos_one: '{{count}} contrato',
    contratos_other: '{{count}} contratos',
    inadimplentes_one: '{{count}} inadimplente ({{valor}})',
    inadimplentes_other: '{{count}} inadimplentes ({{valor}})',
    reativacao: 'reativação {{valor}}',
    taxaChurn: 'churn de {{taxa}} do MRR inicial',
  },
  filtros: { estado: 'Filtrar por estado', todos: 'Todos os estados', saude: 'Filtrar por saúde', todas: 'Toda saúde', comFalha: 'Com falha', inadimplentes: 'Inadimplentes' },
  vazio: {
    contratos: 'Nenhum contrato ainda. Crie o primeiro ou importe a planilha do sistema antigo.',
    reajustesPendentes: 'Nenhum reajuste pendente. Um mês antes do aniversário de cada contrato com índice, a aprovação aparece aqui.',
    reajustesTodos: 'Nenhum reajuste ainda.',
  },
  encerrar: {
    titulo: 'Encerrar o contrato?',
    texto_one: 'A cobrança agendada será cancelada e o contrato sai do MRR. Para voltar a cobrar, use Reativar.',
    texto_other: 'As {{count}} cobranças agendadas serão canceladas e o contrato sai do MRR. Para voltar a cobrar, use Reativar.',
    motivo: 'Motivo do encerramento',
    faturas_one: '{{count}} fatura futura sem baixa foi cancelada no Contas.',
    faturas_other: '{{count}} faturas futuras sem baixa foram canceladas no Contas.',
    emitidas_one: '{{count}} fatura futura ficou no Contas (com baixa ou sem permissão para cancelar): confira em Contas a receber.',
    emitidas_other: '{{count}} faturas futuras ficaram no Contas (com baixa ou sem permissão para cancelar): confira em Contas a receber.',
  },
  planos: {
    novo: 'Novo plano',
    itens: 'Serviços do plano',
    preco: 'Preço do ciclo',
    vazio: 'Nenhum plano ainda. Crie um plano para começar contratos com os mesmos serviços e a mesma recorrência.',
    ativo: 'Ativo',
    inativo: 'Inativo',
    ativos: 'Ativos',
    inativos: 'Inativos',
    todos: 'Todos os planos',
    filtroAtivo: 'Filtrar por situação do plano',
    contratosAtivos_one: '{{count}} contrato ativo nasceu deste plano. Mudar o plano não muda os contratos que já existem.',
    contratosAtivos_other: '{{count}} contratos ativos nasceram deste plano. Mudar o plano não muda os contratos que já existem.',
    excluirTitulo: 'Excluir o plano?',
    excluirTexto: 'O plano vai para a lixeira. Plano que já gerou contrato não sai: desative-o.',
    campos: { nome: 'Nome do plano', descricao: 'Descrição', ativo: 'Plano ativo', itens: 'Itens', contratos: 'Contratos ativos' },
    ajuda: { ativo: 'Plano inativo não gera contrato novo; os contratos existentes não mudam.' },
  },
  reativar: { titulo: 'Reativar o contrato?', texto: 'O contrato volta a ativo e fatura a partir de hoje. O período em que ficou encerrado não é cobrado, e as faturas canceladas no encerramento continuam canceladas.' },
  inadimplencia: { selo: 'Inadimplente', desde: 'Inadimplente: fatura vencida desde {{data}}', reativadoEm: 'Reativado em {{data}}' },
  excluir: { titulo: 'Excluir o rascunho?', texto: 'O rascunho some da lista. Contrato que já faturou é encerrado, nunca excluído.' },
  reajustes: {
    filtro: 'Mostrar reajustes',
    pendentes: 'Pendentes',
    todos: 'Todos',
    aniversario: 'Aniversário {{mes}}',
    acumulado: 'acumulado {{pct}}',
    periodo: 'Índice de {{de}} a {{ate}}',
    valorAntigo: 'Valor atual do ciclo',
    valorNovo: 'Valor reajustado',
    estado: { pendente: 'Pendente', aprovado: 'Aprovado', recusado: 'Recusado' },
    aprovadoMsg: 'Reajuste aprovado',
    recusadoMsg: 'Reajuste recusado: o valor fica como está',
    ajustadas_one: '{{count}} cobrança futura ajustada',
    ajustadas_other: '{{count}} cobranças futuras ajustadas',
    semResposta: 'Sem resposta, o faturamento segue no valor atual.',
  },
  mensagens: {
    criado: 'Contrato {{numero}} criado',
    faturado_one: '{{count}} fatura emitida',
    faturado_other: '{{count}} faturas emitidas',
    nadaAFaturar: 'Nada para emitir hoje',
    comFalha_one: '{{count}} cobrança falhou: veja a saúde do faturamento',
    comFalha_other: '{{count}} cobranças falharam: veja a saúde do faturamento',
    pausado: 'Contrato pausado',
    retomado: 'Contrato retomado',
    ativado: 'Contrato ativado',
    encerrado: 'Contrato encerrado',
    reativado: 'Contrato reativado',
  },
  // Lote de 19/10 (item 9): nomes da tela e dos campos em Admin > Configurações > Campos das telas.
  camposTela: {
    contrato: {
      titulo: 'Contratos',
      campos: { parceiro_id: 'Cliente', tipo: 'Tipo', inicio: 'Início', primeira_cobranca: 'Primeira cobrança', dia_geracao: 'Dia de geração', dia_vencimento: 'Dia de vencimento', indice: 'Índice de reajuste', plano_id: 'Plano', vendedor_id: 'Vendedor', referencia_externa: 'Referência externa', centro_custo_id: 'Centro de custo', desconto: 'Desconto', forma_pagamento_id: 'Forma de pagamento', condicao_pagamento_id: 'Condição de pagamento', observacoes_fatura: 'Observações da fatura' },
    },
  },
};

type Dic = typeof pt;

const en: Dic = {
  nome: 'Subscriptions and recurring billing',
  buscaGlobal: { contratos: 'Subscription contracts' },
  abas: { contratos: 'Contracts', reajustes: 'Adjustments', planos: 'Plans', onboarding: 'Onboarding' },
  onboarding: {
    config: {
      titulo: 'Customer cycle',
      onboarding: 'Onboarding when the contract is activated',
      onboardingAjuda: 'When a contract is activated, the customer onboarding opens: tax data, app invitation, first Pix charge and welcome. Contracts already active are not touched.',
      ganhoAtivo: 'Contract active right on the win',
      ganhoAtivoAjuda: 'The contract proposed when the opportunity is won (with its items) is created active and bills; off, it is created as a draft for review.',
      exigePortal: 'Turning this on also requires the permission to invite to the customer Portal (portal access), which you do not have.',
      tarefas: 'Manual steps become tasks',
      quadro: 'Task board',
      quadroPadrao: 'Default board',
      inadimplencia: 'Arrears tolerance, in days',
      inadimplenciaFaixa: 'Use 0 to 90 days',
      ativarAoAssinar: 'Activate the contract on signature',
      ativarAoAssinarAjuda: 'Per company. When everyone signs the document of a contract generated from a template, the draft contract activates and issues the first charge, with the permissions of who sent it for signature. Off: the contract gets a note and whoever generated the document is notified.',
      ganho: 'When the opportunity is won',
      ganhoAvisar: 'Who is notified',
      ganhoAvisarTodos: 'Everyone with access to Subscriptions (default)',
      ganhoAvisarIncluir: 'Add person',
      ganhoAvisarRemover: 'Remove {{nome}} from the notice',
      ganhoAvisarAjuda: 'Each contract created by a won deal notifies these people (bell and phone), with the link to the contract. With nobody chosen, it notifies whoever has access to Subscriptions in the contract company; each person adjusts the channel in the notification preferences.',
      ganhoTarefa: 'Task for the responsible team',
      ganhoTarefaAjuda: 'Each contract created by a won deal becomes a card on the team board, linked to the contract and with the link to it in Subscriptions.',
      ganhoQuadro: 'Team board',
      ganhoResponsavel: 'Card assignee',
      semResponsavel: 'No assignee',
      inadimplenciaAjuda: 'A contract with an open invoice overdue for more than these days shows as in arrears and the team is notified. Collection from the customer follows the Accounts dunning schedule.',
    },
    modelo: {
      titulo: 'Onboarding template',
      padraoAjuda: 'This is the default template. Customize it to change texts, deadlines and steps.',
      ajuda: 'Changes apply to onboardings opened from now on; the open ones stay as they are.',
      personalizar: 'Customize',
      nova: 'New step',
      editar: 'Edit step',
      remover: 'Remove step',
      removerTitulo: 'Remove this step from the template?',
      removerTexto: 'Onboardings already open stay as they are.',
      campoTitulo: 'Title',
      campoDescricao: 'Description',
      campoMensagem: 'Welcome message text',
      campoPrazo: 'Deadline in days',
      prazo_one: '{{count}} day',
      prazo_other: '{{count}} days',
      semPrazo: 'No deadline',
    },
    tipos: { dados_fiscais: 'Automatic: tax data', convite_portal: 'Automatic: app invitation', cobranca_pix: 'Automatic: Pix charge', boas_vindas: 'Automatic: welcome', manual: 'Manual' },
    estadoPasso: { pendente: 'Pending', aguardando: 'Waiting', concluido: 'Done', falhou: 'Failed', dispensado: 'Skipped' },
    estadoOnboarding: { em_andamento: 'In progress', concluido: 'Done', cancelado: 'Canceled' },
    ficha: {
      titulo: 'Onboarding',
      doContrato: 'Onboarding of contract {{numero}}',
      unico_one: 'Customer onboarding',
      unico_other: 'Customer onboarding: {{count}} contracts from the same win, one per company',
      desde: 'since {{data}}',
      prazo: 'by {{data}}',
      executar: 'Run again',
      concluir: 'Mark as done',
      dispensar: 'Skip',
      reabrir: 'Reopen',
    },
    detalhes: {
      sem_documento: "Add the customer's tax ID (CPF or CNPJ, required to charge)",
      cliente_indisponivel: 'Customer unavailable in Records',
      portal_ausente: 'The Customer Portal is not installed',
      sem_email: 'Add the e-mail of the customer or of a contact',
      convite_enviado: 'Invitation sent to the main contact',
      ja_tinha_acesso: 'The contact already had access to the app',
      aguardando_dados_fiscais: 'Waiting for the tax data',
      aguardando_fatura: "Waiting for the contract's first invoice",
      aguardando_pagamento: 'Pix charge requested; done when the payment arrives',
      fatura_paga: 'The first invoice was already paid',
      pagamento_confirmado: 'Payment confirmed',
      contas_ausente: 'Receivables is not available to charge',
      aguardando_convite: 'Waiting for the app invitation',
      mensagem_enviada: 'Message sent in the app',
      tarefa_criada: 'Task #{{numero}} created',
      tarefa_nao_criada: 'The task was not created',
      marcado_pela_equipe: 'Marked by the team',
      sem_permissao: 'Whoever ran this step lacks the permission for it: someone who has it can use "Run again"',
      sem_permissao_manual: 'The task for this step was not created: whoever activated the contract cannot create tasks. Someone who can uses "Run again"',
      simulacao_manual: 'The task for this step was not created because the contract was activated in a simulation. Someone who can uses "Run again"',
      simulacao: 'This step did not run because the action was taken in a simulation: someone with the permission can use "Run again"',
    },
  },
  indicadores: { mrr: 'MRR', reajustes_pendentes: 'Pending adjustments' },
  anexarAssinado: {
    titulo: 'Attach signed contract',
    ajuda: 'For a contract already signed outside the system: the PDF is linked to this contract, in Records > Documents and signature > Contracts, without generating it again.',
    nome: 'Document name',
    nomeAjuda: 'Empty: the file name',
    arquivo: 'Signed file (PDF)',
    escolher: 'Choose file',
    trocar: 'Change file',
    anexar: 'Attach',
    anexado: 'Signed contract attached',
    arquivoObrigatorio: 'Choose the signed contract file',
  },
  documento: {
    titulo: 'Generate contract document',
    gerar: 'Generate document',
    ajuda: 'The document comes from the Word template with the contract, customer and company data. It goes to Records > Documents and signature > Contracts, as a PDF to sign.',
    ajudaSemPdf: 'The document comes from the Word template with the contract, customer and company data. This server does not convert to PDF yet: the document comes out as .docx.',
    modelo: 'Template',
    sugerido: '{{nome}} (suggested)',
    escolha: 'Choose the template',
    versao: 'Template version {{versao}}',
    garantidor: 'Guarantor partner',
    garantidorAjuda: 'Who signs as guarantor or joint debtor.',
    campos: 'Document fields',
    doSistema: 'Filled in by the system; you can correct it.',
    pendentes_one: '{{count}} required field left to fill in.',
    pendentes_other: '{{count}} required fields left to fill in.',
    semModelo: 'No active Word contract template. Import one in Records > Documents and signature > Contracts > Templates.',
    gerado: 'Document generated.',
    geradoSemPdf: 'Document generated as .docx (no PDF on this server).',
  },
  aditivo: {
    titulo: 'Generate amendment or term',
    gerar: 'Generate amendment or term',
    evento: 'Event',
    eventos: { suspensao: 'Suspension', reativacao: 'Reactivation', migracao_plano: 'Plan migration', troca_regime: 'Tax regime change', rescisao: 'Termination without debts', cessao: 'Assignment to another group company', rescisao_inadimplencia: 'Termination for non-payment (notice to the client)' },
    antigo: 'Old contract (no contract generated in MalgoOS): the "old contracts only" templates also apply.',
    data: 'Starting from',
    dataRescisao: 'Termination effective date',
    dataCessao: 'Assignment date',
    destino: 'Company that receives the contract',
    destinoAjuda: 'On signature, the contract is created in this company with the same items from the date, and the one in this company ends (counts as churn here and new there).',
    escolhaDestino: 'Choose the company',
    faltaDestino: 'Choose the receiving company for the assignment to take effect on signature.',
    dataAjuda: 'Empty: today.',
    plano: 'New plan',
    planoAjuda: 'The new amendment value comes from the plan chosen in the Plans catalog.',
    escolhaPlano: 'Choose the plan',
    efeito: 'When the change takes effect',
    efeitos: { ja: 'Takes effect now', assinatura: 'Takes effect on signature' },
    ajuda: {
      ja: 'The document only formalizes it: make the change in the contract as usual.',
      assinatura: 'The system applies the change to the contract when everyone signs, with the permissions of whoever sends it for signature.',
    },
    soFormaliza: 'A tax regime change is only formalized: the regime changes in the client record.',
    faltaPlano: 'Choose the new plan: the new amendment value comes from it.',
    semModelo: 'No Word amendment or term template for this event. Import one in Records > Documents and signature > Contracts > Templates, with the type and the event.',
    geradoPendente: 'Document generated. The change takes effect when everyone signs.',
  },
  acoes: {
    gerarDocumento: 'Generate document',
    gerarAditivo: 'Generate amendment or term',
    anexarAssinado: 'Attach signed contract',
    novo: 'New contract',
    importar: 'Import CSV',
    importarTitulo: 'Import contracts',
    editar: 'Edit',
    pausar: 'Pause',
    retomar: 'Resume',
    ativar: 'Activate',
    encerrar: 'End contract',
    reativar: 'Reactivate contract',
    faturar: 'Try again',
    excluir: 'Delete draft',
    aprovar: 'Approve',
    recusar: 'Decline',
    editarContrato: 'Edit contract',
    verFatura: 'View invoice in Accounts',
  },
  campos: {
    numero: 'Number',
    referencia: 'External reference',
    cliente: 'Customer',
    vendedor: 'Salesperson',
    tipo: 'Contract type',
    inicio: 'Start date',
    primeiraCobranca: 'First billing',
    intervalo: 'Recurrence',
    intervaloMeses: 'Every',
    fimTipo: 'Contract term',
    fimData: 'End date',
    fimCobrancas: 'Number of billings',
    diaGeracao: 'Invoice generation day',
    diaVencimento: 'Due day',
    momento: 'Payment type',
    forma: 'Payment method',
    condicao: 'Payment terms',
    descontoTipo: 'Discount',
    desconto: 'Discount amount',
    descontoPct: 'Discount in %',
    indice: 'Adjustment index',
    observacoes: 'Invoice notes',
    estado: 'Status',
    valorCiclo: 'Cycle amount',
    mrr: 'MRR',
    saude: 'Billing health',
    proxima: 'Next billing',
    termino: 'End',
    competencia: 'Period',
    geracao: 'Generation',
    vencimento: 'Due date',
    valor: 'Amount',
    fator: 'Accumulated factor',
    repete: 'Repeats every',
    unidade: 'Repeat unit',
    empresa: 'Company',
    centroCusto: 'Cost center',
    plano: 'Plan',
    planoInativo: 'Unavailable plan',
  },
  tipos: { recorrente: 'Recurring', avulso: 'One-off (single billing)' },
  fins: { indeterminado: 'Open-ended', data: 'Until a date', cobrancas: 'Number of billings' },
  momentos: { vigente: 'Current month', subsequente: 'Following month' },
  indices: { nenhum: 'None', igpm: 'IGP-M', ipca: 'IPCA', inpc: 'INPC', selic: 'SELIC' },
  estados: { rascunho: 'Draft', ativo: 'Active', pausado: 'Paused', encerrado: 'Ended' },
  estadosCobranca: { agendada: 'Scheduled', emitida: 'Issued', falhou: 'Failed', cancelada: 'Canceled' },
  motivos: { encerramento: 'Canceled when the contract ended', pausa: 'Canceled by the pause' },
  descontoTipos: { nenhum: 'No discount', valor: 'Amount', percentual: 'Percentage' },
  areas: { identificacao: 'Identification', servicos: 'Contract services', vigencia: 'Type and term', pagamento: 'Payment' },
  unidades: { dia: 'Days', semana: 'Weeks', mes: 'Months' },
  intervalos: { '1': 'Monthly', '3': 'Quarterly', '6': 'Every six months', '12': 'Yearly', semanal: 'Weekly', outro: 'Other interval' },
  recorrencia: { aCadaSemanas_one: 'Every {{count}} week', aCadaSemanas_other: 'Every {{count}} weeks', aCadaDias_one: 'Every {{count}} day', aCadaDias_other: 'Every {{count}} days', diaria: 'Daily', aCada_one: 'Every {{count}} month', aCada_other: 'Every {{count}} months', avulso: 'Single billing' },
  itens: {
    titulo: 'Contract services',
    servico: 'Service',
    semServico: 'No catalog service',
    descricao: 'Invoice description of service {{n}}',
    quantidade: 'Quantity',
    preco: 'Unit price',
    custo: 'Unit cost',
    categoria: 'Financial account (revenue)',
    semCategoria: 'No category',
    centro: 'Cost center',
    semCentro: 'No cost center',
    total: 'Total',
    adicionar: 'Add service',
    remover: 'Remove service',
    bruto: 'Gross amount',
    desconto: 'Discount',
    liquido: 'Cycle amount',
    mrr: 'Contract MRR',
    vazio: 'No items. An active contract needs at least one item.',
    incompleto: 'Fill in the description and a valid price on every item.',
    recorrencia: 'Recurrence',
    daContrato: "The contract's",
  },
  recorrenciaItem: { avulso: 'One-off (first billing only)', mensal: 'Monthly', trimestral: 'Quarterly', semestral: 'Every six months', anual: 'Yearly' },
  ajuda: {
    primeiraCobranca: 'Its month is the period of the first billing.',
    diaGeracao: 'Day the invoice is created in Accounts. If it falls after the due date, it is created the month before.',
    diaVencimento: 'Empty: the day of the first billing. Day 31 becomes the last day in short months.',
    indice: 'One month before each anniversary, an approval appears with the 12-month accumulated index.',
    referencia: 'Contract number in the source system (used by the import).',
    momento: 'Current: due in the period month (by day or week, on the cycle date). Following: due the month after (by day or week, on the next cycle).',
    empresa: 'The company (tax ID) of the contract and its charges. With the top filter on one company, it is that one.',
    centroCusto: 'Default for services without a cost center.',
    numeroAoSalvar: 'Generated on save',
    unidade: 'By day or by week, the invoice is created on each cycle date; generation day and due day do not apply.',
    plano: 'Brings the plan items and recurrence; everything stays editable.',
    planoEdicao: 'Changing the plan does not change the items of this contract.',
  },
  saude: {
    emDia: 'Up to date',
    falhas_one: '{{count}} billing failed',
    falhas_other: '{{count}} billings failed',
    ultima: 'Last issued: {{competencia}}',
    semEmissao: 'No invoice issued yet',
    proxima: 'Next: {{competencia}}, created on {{data}}',
    semProxima: 'No next billing scheduled',
    ultimoErro: 'Last error: {{erro}}',
  },
  banco: { titulo: 'Charging', rotulo: 'Charging bank', ajuda: 'Bank that creates the charge for the invoices of this contract.', segue: 'Follows the customer, the company and the workspace', opcoes: { asaas: 'Asaas', sicredi: 'Sicredi Pix', nenhum: 'None (no charge)' } },
  detalhe: {
    resumo: 'Summary',
    cobrancas: 'Billings',
    previsao: 'Upcoming billings',
    reajustes: 'Adjustments',
    semReajustes: 'No adjustments so far.',
    semCobrancas: 'No billing planned. Drafts and contracts without items are not billed.',
    reajustada: 'Adjusted',
    tentativas_one: '{{count}} attempt',
    tentativas_other: '{{count}} attempts',
    cobrancasLegenda: '12-month forecast: scheduled billings become invoices in Accounts on the generation day.',
    cobrancasLegendaDias: '2-month forecast: scheduled billings become invoices in Accounts on the generation day.',
    carregarAnteriores: 'Load earlier billings',
  },
  mrr: {
    titulo: 'MRR',
    arr: 'ARR',
    pausado: 'Paused MRR',
    aIniciar: 'MRR to start',
    movimento: 'Movement this month',
    detalheMovimento: 'New {{novo}}, expansion {{expansao}}, churn {{churn}}',
    contratos_one: '{{count}} contract',
    contratos_other: '{{count}} contracts',
    inadimplentes_one: '{{count}} in arrears ({{valor}})',
    inadimplentes_other: '{{count}} in arrears ({{valor}})',
    reativacao: 'reactivation {{valor}}',
    taxaChurn: 'churn of {{taxa}} of the starting MRR',
  },
  filtros: { estado: 'Filter by status', todos: 'All statuses', saude: 'Filter by health', todas: 'Any health', comFalha: 'With failures', inadimplentes: 'In arrears' },
  vazio: {
    contratos: 'No contracts yet. Create the first one or import the spreadsheet from the old system.',
    reajustesPendentes: 'No pending adjustments. One month before the anniversary of each indexed contract, the approval shows up here.',
    reajustesTodos: 'No adjustments yet.',
  },
  encerrar: {
    titulo: 'End the contract?',
    texto_one: 'The scheduled billing will be canceled and the contract leaves the MRR. To bill again, use Reactivate.',
    texto_other: 'The {{count}} scheduled billings will be canceled and the contract leaves the MRR. To bill again, use Reactivate.',
    motivo: 'Reason for ending',
    faturas_one: '{{count}} future invoice without payments was canceled in Accounts.',
    faturas_other: '{{count}} future invoices without payments were canceled in Accounts.',
    emitidas_one: '{{count}} future invoice stayed in Accounts (with a payment or without permission to cancel): check Receivables.',
    emitidas_other: '{{count}} future invoices stayed in Accounts (with payments or without permission to cancel): check Receivables.',
  },
  planos: {
    novo: 'New plan',
    itens: 'Plan services',
    preco: 'Cycle price',
    vazio: 'No plans yet. Create a plan to start contracts with the same services and the same recurrence.',
    ativo: 'Active',
    inativo: 'Inactive',
    ativos: 'Active',
    inativos: 'Inactive',
    todos: 'All plans',
    filtroAtivo: 'Filter by plan status',
    contratosAtivos_one: '{{count}} active contract came from this plan. Changing the plan does not change existing contracts.',
    contratosAtivos_other: '{{count}} active contracts came from this plan. Changing the plan does not change existing contracts.',
    excluirTitulo: 'Delete the plan?',
    excluirTexto: 'The plan goes to the trash. A plan that already created contracts cannot be deleted: deactivate it.',
    campos: { nome: 'Plan name', descricao: 'Description', ativo: 'Active plan', itens: 'Items', contratos: 'Active contracts' },
    ajuda: { ativo: 'An inactive plan does not create new contracts; existing contracts do not change.' },
  },
  reativar: { titulo: 'Reactivate the contract?', texto: 'The contract becomes active again and bills from today. The period it was ended is not billed, and the invoices canceled when it ended stay canceled.' },
  inadimplencia: { selo: 'In arrears', desde: 'In arrears: invoice overdue since {{data}}', reativadoEm: 'Reactivated on {{data}}' },
  excluir: { titulo: 'Delete the draft?', texto: 'The draft leaves the list. A contract that already billed is ended, never deleted.' },
  reajustes: {
    filtro: 'Show adjustments',
    pendentes: 'Pending',
    todos: 'All',
    aniversario: 'Anniversary {{mes}}',
    acumulado: 'accumulated {{pct}}',
    periodo: 'Index from {{de}} to {{ate}}',
    valorAntigo: 'Current cycle amount',
    valorNovo: 'Adjusted amount',
    estado: { pendente: 'Pending', aprovado: 'Approved', recusado: 'Declined' },
    aprovadoMsg: 'Adjustment approved',
    recusadoMsg: 'Adjustment declined: the amount stays as it is',
    ajustadas_one: '{{count}} future billing adjusted',
    ajustadas_other: '{{count}} future billings adjusted',
    semResposta: 'Without an answer, billing continues at the current amount.',
  },
  mensagens: {
    criado: 'Contract {{numero}} created',
    faturado_one: '{{count}} invoice issued',
    faturado_other: '{{count}} invoices issued',
    nadaAFaturar: 'Nothing to issue today',
    comFalha_one: '{{count}} billing failed: see the billing health',
    comFalha_other: '{{count}} billings failed: see the billing health',
    pausado: 'Contract paused',
    retomado: 'Contract resumed',
    ativado: 'Contract activated',
    encerrado: 'Contract ended',
    reativado: 'Contract reactivated',
  },
  // Lote de 19/10 (item 9): nomes da tela e dos campos em Admin > Configurações > Campos das telas.
  camposTela: {
    contrato: {
      titulo: 'Contracts',
      campos: { parceiro_id: 'Customer', tipo: 'Type', inicio: 'Start', primeira_cobranca: 'First billing', dia_geracao: 'Generation day', dia_vencimento: 'Due day', indice: 'Adjustment index', plano_id: 'Plan', vendedor_id: 'Salesperson', referencia_externa: 'External reference', centro_custo_id: 'Cost center', desconto: 'Discount', forma_pagamento_id: 'Payment method', condicao_pagamento_id: 'Payment terms', observacoes_fatura: 'Invoice notes' },
    },
  },
};

const es: Dic = {
  nome: 'Suscripciones y recurrencia',
  buscaGlobal: { contratos: 'Contratos de suscripción' },
  abas: { contratos: 'Contratos', reajustes: 'Reajustes', planos: 'Planes', onboarding: 'Onboarding' },
  onboarding: {
    config: {
      titulo: 'Ciclo del cliente',
      onboarding: 'Onboarding al activar el contrato',
      onboardingAjuda: 'Al activar un contrato, se abre el onboarding del cliente: datos fiscales, invitación a la app, primer cobro Pix y bienvenida. No cambia los contratos ya activos.',
      ganhoAtivo: 'Contrato activo directo al ganar',
      ganhoAtivoAjuda: 'El contrato propuesto al ganar la oportunidad (con sus ítems) nace activo y ya factura; apagado, nace en borrador para revisión.',
      exigePortal: 'Activarlo exige también el permiso de invitar al Portal del cliente (accesos al portal), que no tienes.',
      tarefas: 'Las etapas manuales se vuelven tareas',
      quadro: 'Tablero de las tareas',
      quadroPadrao: 'Tablero predeterminado',
      inadimplencia: 'Tolerancia de la mora, en días',
      inadimplenciaFaixa: 'Usa de 0 a 90 días',
      ativarAoAssinar: 'Activar el contrato al firmar',
      ativarAoAssinarAjuda: 'Por empresa. Cuando todos firman el documento del contrato generado de plantilla, el contrato en borrador se activa y emite el primer cobro, con el permiso de quien lo envió a firmar. Desactivada, el contrato recibe una nota y se avisa a quien generó el documento.',
      ganho: 'Al ganar la oportunidad',
      ganhoAvisar: 'Quién recibe el aviso',
      ganhoAvisarTodos: 'Quien tiene acceso a Suscripciones (predeterminado)',
      ganhoAvisarIncluir: 'Incluir persona',
      ganhoAvisarRemover: 'Quitar a {{nome}} del aviso',
      ganhoAvisarAjuda: 'Cada contrato que nace de una venta ganada avisa a estas personas (campana y celular), con el enlace al contrato. Sin nadie elegido, avisa a quien tiene acceso a Suscripciones en la empresa del contrato; cada persona ajusta el canal en las preferencias de notificación.',
      ganhoTarefa: 'Tarea para el sector responsable',
      ganhoTarefaAjuda: 'Cada contrato que nace de una venta ganada se vuelve una tarjeta en el tablero del sector, vinculada al contrato y con el enlace a él en Suscripciones.',
      ganhoQuadro: 'Tablero del sector',
      ganhoResponsavel: 'Responsable de la tarjeta',
      semResponsavel: 'Sin responsable',
      inadimplenciaAjuda: 'El contrato con una factura pendiente vencida hace más de estos días aparece en mora y se avisa al equipo. El cobro al cliente sigue la regla de cobranza de Cuentas.',
    },
    modelo: {
      titulo: 'Modelo de onboarding',
      padraoAjuda: 'Este es el modelo predeterminado. Personalízalo para cambiar textos, plazos y etapas.',
      ajuda: 'Los cambios valen para los onboardings que se abran después; los abiertos quedan como están.',
      personalizar: 'Personalizar',
      nova: 'Nueva etapa',
      editar: 'Editar etapa',
      remover: 'Quitar etapa',
      removerTitulo: '¿Quitar esta etapa del modelo?',
      removerTexto: 'Los onboardings ya abiertos quedan como están.',
      campoTitulo: 'Título',
      campoDescricao: 'Descripción',
      campoMensagem: 'Texto del mensaje de bienvenida',
      campoPrazo: 'Plazo en días',
      prazo_one: '{{count}} día',
      prazo_other: '{{count}} días',
      semPrazo: 'Sin plazo',
    },
    tipos: { dados_fiscais: 'Automática: datos fiscales', convite_portal: 'Automática: invitación a la app', cobranca_pix: 'Automática: cobro Pix', boas_vindas: 'Automática: bienvenida', manual: 'Manual' },
    estadoPasso: { pendente: 'Pendiente', aguardando: 'En espera', concluido: 'Hecha', falhou: 'Con falla', dispensado: 'Omitida' },
    estadoOnboarding: { em_andamento: 'En curso', concluido: 'Concluido', cancelado: 'Cancelado' },
    ficha: {
      titulo: 'Onboarding',
      doContrato: 'Onboarding del contrato {{numero}}',
      unico_one: 'Onboarding del cliente',
      unico_other: 'Onboarding del cliente: {{count}} contratos de la misma venta, uno por empresa',
      desde: 'desde {{data}}',
      prazo: 'hasta {{data}}',
      executar: 'Ejecutar de nuevo',
      concluir: 'Marcar como hecha',
      dispensar: 'Omitir',
      reabrir: 'Reabrir',
    },
    detalhes: {
      sem_documento: 'Registra el CPF o CNPJ del cliente (obligatorio para cobrar)',
      cliente_indisponivel: 'Cliente no disponible en Registros',
      portal_ausente: 'El Portal del cliente no está instalado',
      sem_email: 'Registra el correo del cliente o de un contacto',
      convite_enviado: 'Invitación enviada al contacto principal',
      ja_tinha_acesso: 'El contacto ya tenía acceso a la app',
      aguardando_dados_fiscais: 'Esperando los datos fiscales',
      aguardando_fatura: 'Esperando la primera factura del contrato',
      aguardando_pagamento: 'Cobro Pix solicitado; se concluye cuando entre el pago',
      fatura_paga: 'La primera factura ya estaba pagada',
      pagamento_confirmado: 'Pago confirmado',
      contas_ausente: 'Cuentas no está disponible para cobrar',
      aguardando_convite: 'Esperando la invitación a la app',
      mensagem_enviada: 'Mensaje enviado en la app',
      tarefa_criada: 'Tarea #{{numero}} creada',
      tarefa_nao_criada: 'La tarea no se creó',
      marcado_pela_equipe: 'Marcada por el equipo',
      sem_permissao: 'Quien ejecutó esta etapa no tiene el permiso: alguien con el permiso usa "Ejecutar de nuevo"',
      sem_permissao_manual: 'La tarea de esta etapa no se creó: quien activó el contrato no puede crear tareas. Alguien con el permiso usa "Ejecutar de nuevo"',
      simulacao_manual: 'La tarea de esta etapa no se creó porque el contrato se activó en una simulación. Alguien con el permiso usa "Ejecutar de nuevo"',
      simulacao: 'Esta etapa no se ejecutó porque la acción se hizo en una simulación: alguien con el permiso usa "Ejecutar de nuevo"',
    },
  },
  indicadores: { mrr: 'MRR', reajustes_pendentes: 'Reajustes pendientes' },
  anexarAssinado: {
    titulo: 'Adjuntar contrato firmado',
    ajuda: 'Para el contrato ya firmado fuera del sistema: el PDF queda ligado a este contrato, en Registros > Documentos y firma > Contratos, sin generarlo de nuevo.',
    nome: 'Nombre del documento',
    nomeAjuda: 'Vacío: el nombre del archivo',
    arquivo: 'Archivo firmado (PDF)',
    escolher: 'Elegir archivo',
    trocar: 'Cambiar archivo',
    anexar: 'Adjuntar',
    anexado: 'Contrato firmado adjuntado',
    arquivoObrigatorio: 'Elige el archivo del contrato firmado',
  },
  documento: {
    titulo: 'Generar documento del contrato',
    gerar: 'Generar documento',
    ajuda: 'El documento sale de la plantilla de Word con los datos del contrato, del cliente y de la empresa. Queda en Registros > Documentos y firma > Contratos, en PDF para firmar.',
    ajudaSemPdf: 'El documento sale de la plantilla de Word con los datos del contrato, del cliente y de la empresa. Este servidor todavía no convierte a PDF: el documento sale en .docx.',
    modelo: 'Plantilla',
    sugerido: '{{nome}} (sugerida)',
    escolha: 'Elige la plantilla',
    versao: 'Versión {{versao}} de la plantilla',
    garantidor: 'Socio garante',
    garantidorAjuda: 'Quien firma como garante o deudor solidario.',
    campos: 'Campos del documento',
    doSistema: 'Llenado por el sistema; puedes corregirlo.',
    pendentes_one: 'Falta llenar {{count}} campo obligatorio.',
    pendentes_other: 'Faltan llenar {{count}} campos obligatorios.',
    semModelo: 'Ninguna plantilla de contrato de Word activa. Importa una en Registros > Documentos y firma > Contratos > Plantillas.',
    gerado: 'Documento generado.',
    geradoSemPdf: 'Documento generado en .docx (sin PDF en este servidor).',
  },
  aditivo: {
    titulo: 'Generar adenda o término',
    gerar: 'Generar adenda o término',
    evento: 'Evento',
    eventos: { suspensao: 'Suspensión', reativacao: 'Reactivación', migracao_plano: 'Migración de plan', troca_regime: 'Cambio de régimen', rescisao: 'Rescisión sin deudas', cessao: 'Cesión a otra empresa del grupo', rescisao_inadimplencia: 'Rescisión por impago (aviso al cliente)' },
    antigo: 'Contrato antiguo (sin contrato generado en MalgoOS): sirven también las plantillas "solo contratos antiguos".',
    data: 'A partir de',
    dataRescisao: 'Fecha del efecto de la rescisión',
    dataCessao: 'Fecha de la cesión',
    destino: 'Empresa que recibe el contrato',
    destinoAjuda: 'En la firma, el contrato nace en esta empresa con los mismos ítems a partir de la fecha, y el de esta empresa se finaliza (cuenta como salida aquí y entrada allá).',
    escolhaDestino: 'Elige la empresa',
    faltaDestino: 'Elige la empresa que recibe para que la cesión valga en la firma.',
    dataAjuda: 'Vacío: hoy.',
    plano: 'Plan nuevo',
    planoAjuda: 'El nuevo valor de la adenda sale del plan elegido en el catálogo de Planes.',
    escolhaPlano: 'Elige el plan',
    efeito: 'Cuándo vale el cambio',
    efeitos: { ja: 'Vale ya', assinatura: 'Vale en la firma' },
    ajuda: {
      ja: 'El documento solo formaliza: haz el cambio en el contrato como siempre.',
      assinatura: 'El sistema aplica el cambio en el contrato cuando todos firmen, con los permisos de quien lo envíe a firmar.',
    },
    soFormaliza: 'El cambio de régimen solo se formaliza: el régimen cambia en el registro del cliente.',
    faltaPlano: 'Elige el plan nuevo: el nuevo valor de la adenda sale de él.',
    semModelo: 'Ninguna plantilla de Word de adenda o término para este evento. Importa una en Registros > Documentos y firma > Contratos > Plantillas, con el tipo y el evento.',
    geradoPendente: 'Documento generado. El cambio vale cuando todos firmen.',
  },
  acoes: {
    gerarDocumento: 'Generar documento',
    gerarAditivo: 'Generar adenda o término',
    anexarAssinado: 'Adjuntar contrato firmado',
    novo: 'Nuevo contrato',
    importar: 'Importar CSV',
    importarTitulo: 'Importar contratos',
    editar: 'Editar',
    pausar: 'Pausar',
    retomar: 'Reanudar',
    ativar: 'Activar',
    encerrar: 'Finalizar contrato',
    reativar: 'Reactivar contrato',
    faturar: 'Intentar de nuevo',
    excluir: 'Eliminar borrador',
    aprovar: 'Aprobar',
    recusar: 'Rechazar',
    editarContrato: 'Editar contrato',
    verFatura: 'Ver factura en Cuentas',
  },
  campos: {
    numero: 'Número',
    referencia: 'Referencia externa',
    cliente: 'Cliente',
    vendedor: 'Vendedor',
    tipo: 'Tipo de contrato',
    inicio: 'Fecha de inicio',
    primeiraCobranca: 'Primer cobro',
    intervalo: 'Recurrencia',
    intervaloMeses: 'Cada',
    fimTipo: 'Plazo del contrato',
    fimData: 'Fecha de término',
    fimCobrancas: 'Número de cobros',
    diaGeracao: 'Día de generación del título',
    diaVencimento: 'Día de vencimiento',
    momento: 'Tipo de pago',
    forma: 'Método de pago',
    condicao: 'Condición de pago',
    descontoTipo: 'Descuento',
    desconto: 'Descuento en valor',
    descontoPct: 'Descuento en %',
    indice: 'Índice de reajuste',
    observacoes: 'Observaciones de la factura',
    estado: 'Estado',
    valorCiclo: 'Valor del ciclo',
    mrr: 'MRR',
    saude: 'Salud de la facturación',
    proxima: 'Próximo cobro',
    termino: 'Término',
    competencia: 'Período',
    geracao: 'Generación',
    vencimento: 'Vencimiento',
    valor: 'Valor',
    fator: 'Factor acumulado',
    repete: 'Se repite cada',
    unidade: 'Unidad de repetición',
    empresa: 'Empresa',
    centroCusto: 'Centro de costo',
    plano: 'Plan',
    planoInativo: 'Plan no disponible',
  },
  tipos: { recorrente: 'Recurrente', avulso: 'Puntual (cobro único)' },
  fins: { indeterminado: 'Indefinido', data: 'Hasta una fecha', cobrancas: 'Número de cobros' },
  momentos: { vigente: 'Mes vigente', subsequente: 'Mes siguiente' },
  indices: { nenhum: 'Ninguno', igpm: 'IGP-M', ipca: 'IPCA', inpc: 'INPC', selic: 'SELIC' },
  estados: { rascunho: 'Borrador', ativo: 'Activo', pausado: 'Pausado', encerrado: 'Finalizado' },
  estadosCobranca: { agendada: 'Programado', emitida: 'Emitido', falhou: 'Falló', cancelada: 'Cancelado' },
  motivos: { encerramento: 'Cancelado al finalizar', pausa: 'Cancelado por la pausa' },
  descontoTipos: { nenhum: 'Sin descuento', valor: 'En valor', percentual: 'En porcentaje' },
  areas: { identificacao: 'Identificación', servicos: 'Servicios del contrato', vigencia: 'Tipo y vigencia', pagamento: 'Pago' },
  unidades: { dia: 'Días', semana: 'Semanas', mes: 'Meses' },
  intervalos: { '1': 'Mensual', '3': 'Trimestral', '6': 'Semestral', '12': 'Anual', semanal: 'Semanal', outro: 'Otro intervalo' },
  recorrencia: { aCadaSemanas_one: 'Cada {{count}} semana', aCadaSemanas_other: 'Cada {{count}} semanas', aCadaDias_one: 'Cada {{count}} día', aCadaDias_other: 'Cada {{count}} días', diaria: 'Diaria', aCada_one: 'Cada {{count}} mes', aCada_other: 'Cada {{count}} meses', avulso: 'Cobro único' },
  itens: {
    titulo: 'Servicios del contrato',
    servico: 'Servicio',
    semServico: 'Sin servicio del catálogo',
    descricao: 'Descripción en la factura del servicio {{n}}',
    quantidade: 'Cantidad',
    preco: 'Precio unitario',
    custo: 'Costo unitario',
    categoria: 'Cuenta financiera (ingreso)',
    semCategoria: 'Sin categoría',
    centro: 'Centro de costo',
    semCentro: 'Sin centro de costo',
    total: 'Total',
    adicionar: 'Agregar servicio',
    remover: 'Quitar servicio',
    bruto: 'Valor bruto',
    desconto: 'Descuento',
    liquido: 'Valor del ciclo',
    mrr: 'MRR del contrato',
    vazio: 'Sin ítems. Un contrato activo necesita al menos un ítem.',
    incompleto: 'Completa la descripción y un precio válido en cada ítem.',
    recorrencia: 'Recurrencia',
    daContrato: 'La del contrato',
  },
  recorrenciaItem: { avulso: 'Único (solo en el 1.er cobro)', mensal: 'Mensual', trimestral: 'Trimestral', semestral: 'Semestral', anual: 'Anual' },
  ajuda: {
    primeiraCobranca: 'Su mes es el período del primer cobro.',
    diaGeracao: 'Día en que la factura nace en Cuentas. Si cae después del vencimiento, nace el mes anterior.',
    diaVencimento: 'Vacío: el día del primer cobro. El día 31 pasa al último día en meses cortos.',
    indice: 'Un mes antes de cada aniversario aparece una aprobación con el acumulado de 12 meses.',
    referencia: 'Número del contrato en el sistema de origen (usado en la importación).',
    momento: 'Vigente: vence en el mes del período (por día o semana, en la fecha del ciclo). Siguiente: vence el mes después (por día o semana, en el ciclo siguiente).',
    empresa: 'La empresa (CNPJ) del contrato y de sus cobros. Con el filtro superior en una empresa, es esa.',
    centroCusto: 'Predeterminado de los servicios sin centro de costo.',
    numeroAoSalvar: 'Se genera al guardar',
    unidade: 'Por día o por semana, la factura nace en la fecha de cada ciclo; el día de generación y el de vencimiento no se aplican.',
    plano: 'Trae los ítems y la recurrencia del plan; todo sigue editable.',
    planoEdicao: 'Cambiar el plan no cambia los ítems de este contrato.',
  },
  saude: {
    emDia: 'Al día',
    falhas_one: '{{count}} cobro con falla',
    falhas_other: '{{count}} cobros con falla',
    ultima: 'Último emitido: {{competencia}}',
    semEmissao: 'Ninguna factura emitida todavía',
    proxima: 'Próximo: {{competencia}}, se genera el {{data}}',
    semProxima: 'Sin próximo cobro programado',
    ultimoErro: 'Último error: {{erro}}',
  },
  banco: { titulo: 'Cobro', rotulo: 'Banco del cobro', ajuda: 'Banco que genera el cobro de las facturas de este contrato.', segue: 'Sigue el cliente, la empresa y el workspace', opcoes: { asaas: 'Asaas', sicredi: 'Pix Sicredi', nenhum: 'Ninguno (sin cobro)' } },
  detalhe: {
    resumo: 'Resumen',
    cobrancas: 'Cobros',
    previsao: 'Próximos cobros',
    reajustes: 'Reajustes',
    semReajustes: 'Ningún reajuste hasta ahora.',
    semCobrancas: 'Ningún cobro planificado. Borradores y contratos sin ítems no facturan.',
    reajustada: 'Reajustado',
    tentativas_one: '{{count}} intento',
    tentativas_other: '{{count}} intentos',
    cobrancasLegenda: 'Previsión de 12 meses: los programados se vuelven factura en Cuentas el día de generación.',
    cobrancasLegendaDias: 'Previsión de 2 meses: los programados se vuelven factura en Cuentas el día de generación.',
    carregarAnteriores: 'Cargar cobros anteriores',
  },
  mrr: {
    titulo: 'MRR',
    arr: 'ARR',
    pausado: 'MRR pausado',
    aIniciar: 'MRR por iniciar',
    movimento: 'Movimiento del mes',
    detalheMovimento: 'Nuevo {{novo}}, expansión {{expansao}}, churn {{churn}}',
    contratos_one: '{{count}} contrato',
    contratos_other: '{{count}} contratos',
    inadimplentes_one: '{{count}} en mora ({{valor}})',
    inadimplentes_other: '{{count}} en mora ({{valor}})',
    reativacao: 'reactivación {{valor}}',
    taxaChurn: 'churn del {{taxa}} del MRR inicial',
  },
  filtros: { estado: 'Filtrar por estado', todos: 'Todos los estados', saude: 'Filtrar por salud', todas: 'Toda salud', comFalha: 'Con fallas', inadimplentes: 'En mora' },
  vazio: {
    contratos: 'Todavía no hay contratos. Crea el primero o importa la planilla del sistema anterior.',
    reajustesPendentes: 'Ningún reajuste pendiente. Un mes antes del aniversario de cada contrato con índice, la aprobación aparece aquí.',
    reajustesTodos: 'Ningún reajuste todavía.',
  },
  encerrar: {
    titulo: '¿Finalizar el contrato?',
    texto_one: 'El cobro programado se cancelará y el contrato sale del MRR. Para volver a cobrar, usa Reactivar.',
    texto_other: 'Los {{count}} cobros programados se cancelarán y el contrato sale del MRR. Para volver a cobrar, usa Reactivar.',
    motivo: 'Motivo de la finalización',
    faturas_one: '{{count}} factura futura sin pagos se canceló en Cuentas.',
    faturas_other: '{{count}} facturas futuras sin pagos se cancelaron en Cuentas.',
    emitidas_one: '{{count}} factura futura quedó en Cuentas (con pago o sin permiso para cancelar): revisa Cuentas por cobrar.',
    emitidas_other: '{{count}} facturas futuras quedaron en Cuentas (con pagos o sin permiso para cancelar): revisa Cuentas por cobrar.',
  },
  planos: {
    novo: 'Nuevo plan',
    itens: 'Servicios del plan',
    preco: 'Precio del ciclo',
    vazio: 'Todavía no hay planes. Crea un plan para iniciar contratos con los mismos servicios y la misma recurrencia.',
    ativo: 'Activo',
    inativo: 'Inactivo',
    ativos: 'Activos',
    inativos: 'Inactivos',
    todos: 'Todos los planes',
    filtroAtivo: 'Filtrar por situación del plan',
    contratosAtivos_one: '{{count}} contrato activo nació de este plan. Cambiar el plan no cambia los contratos existentes.',
    contratosAtivos_other: '{{count}} contratos activos nacieron de este plan. Cambiar el plan no cambia los contratos existentes.',
    excluirTitulo: '¿Eliminar el plan?',
    excluirTexto: 'El plan va a la papelera. Un plan que ya generó contratos no se elimina: desactívalo.',
    campos: { nome: 'Nombre del plan', descricao: 'Descripción', ativo: 'Plan activo', itens: 'Ítems', contratos: 'Contratos activos' },
    ajuda: { ativo: 'Un plan inactivo no genera contratos nuevos; los contratos existentes no cambian.' },
  },
  reativar: { titulo: '¿Reactivar el contrato?', texto: 'El contrato vuelve a estar activo y factura desde hoy. El período en que estuvo finalizado no se cobra, y las facturas canceladas al finalizar siguen canceladas.' },
  inadimplencia: { selo: 'En mora', desde: 'En mora: factura vencida desde {{data}}', reativadoEm: 'Reactivado el {{data}}' },
  excluir: { titulo: '¿Eliminar el borrador?', texto: 'El borrador sale de la lista. Un contrato que ya facturó se finaliza, nunca se elimina.' },
  reajustes: {
    filtro: 'Mostrar reajustes',
    pendentes: 'Pendientes',
    todos: 'Todos',
    aniversario: 'Aniversario {{mes}}',
    acumulado: 'acumulado {{pct}}',
    periodo: 'Índice de {{de}} a {{ate}}',
    valorAntigo: 'Valor actual del ciclo',
    valorNovo: 'Valor reajustado',
    estado: { pendente: 'Pendiente', aprovado: 'Aprobado', recusado: 'Rechazado' },
    aprovadoMsg: 'Reajuste aprobado',
    recusadoMsg: 'Reajuste rechazado: el valor queda como está',
    ajustadas_one: '{{count}} cobro futuro ajustado',
    ajustadas_other: '{{count}} cobros futuros ajustados',
    semResposta: 'Sin respuesta, la facturación sigue con el valor actual.',
  },
  mensagens: {
    criado: 'Contrato {{numero}} creado',
    faturado_one: '{{count}} factura emitida',
    faturado_other: '{{count}} facturas emitidas',
    nadaAFaturar: 'Nada para emitir hoy',
    comFalha_one: '{{count}} cobro falló: revisa la salud de la facturación',
    comFalha_other: '{{count}} cobros fallaron: revisa la salud de la facturación',
    pausado: 'Contrato pausado',
    retomado: 'Contrato reanudado',
    ativado: 'Contrato activado',
    encerrado: 'Contrato finalizado',
    reativado: 'Contrato reactivado',
  },
  // Lote de 19/10 (item 9): nomes da tela e dos campos em Admin > Configurações > Campos das telas.
  camposTela: {
    contrato: {
      titulo: 'Contratos',
      campos: { parceiro_id: 'Cliente', tipo: 'Tipo', inicio: 'Inicio', primeira_cobranca: 'Primer cobro', dia_geracao: 'Día de generación', dia_vencimento: 'Día de vencimiento', indice: 'Índice de reajuste', plano_id: 'Plan', vendedor_id: 'Vendedor', referencia_externa: 'Referencia externa', centro_custo_id: 'Centro de costo', desconto: 'Descuento', forma_pagamento_id: 'Forma de pago', condicao_pagamento_id: 'Condición de pago', observacoes_fatura: 'Observaciones de la factura' },
    },
  },
};

export const i18n = { pt, en, es };
